import { render, staticRenderFns } from "./AccountFormLayout.vue?vue&type=template&id=2e96adbc&scoped=true&"
var script = {}
import style0 from "./AccountFormLayout.vue?vue&type=style&index=0&id=2e96adbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e96adbc",
  null
  
)

export default component.exports